<template>
  <div>
    <Modal
      ref="address-review-loading-modal"
      size="sm"
      anchor="centered"
      :showClose="false"
    >
      <template #title>Choose the Correct Address</template>
      <template #content>
        <div class="flex flex-col">
          <Spinner
            message="Loading Recommended Address"
            :size="16"
          />
        </div>
      </template>
    </Modal>
    <Modal
      ref="address-review-modal"
      size="sm"
      anchor="centered"
      :showClose="false"
    >
      <template #title>Choose the Correct Address</template>
      <template #content>
        <div class="flex flex-col">
          <div class="d-block text-center">
            <h3>{{ currentAddressChoice.addressType }} Address</h3>
          </div>
            Possible invalid address:
          <button
            class="mt-1 hover:bg-red-400 border-2 border-red-400 rounded-lg w-full"
            @click="existingAddressOnClick()"
            >{{ getInvalidAddress(currentAddressChoice.address) }}
          </button>
          <div v-if="currentAddressChoice.recommendedAddress === null">
            Address Recommendation Not Found:
          </div>
          <div v-else>
            Did you mean:
          </div>
          <button
            class="mt-1 hover:bg-sky-600 border-2 border-sky-600 rounded-lg w-full"
            @click="suggestedAddressOnClick(currentAddressChoice.addressType, currentAddressChoice.recommendedAddress, currentAddressChoice.identicalAddressList)"
          >
            {{ getRecommendedAddressDisplay(currentAddressChoice.recommendedAddress) }}
          </button>
        </div>
        <!-- <button
          type="button"
          class="rounded-md font-medium text-red-900 bg-red-200 px-3 py-2 hover:bg-red-300 transition-colors shadow-sm"
          @click="() => slotProps.closeModal(true)"
        >
          Confirm
        </button> -->
      </template>
    </Modal>
  </div>
</template>

<script>
import Modal from '../components/Modal.vue'
import Spinner from '../components/Spinner.vue'

import notifications from '../services/notifications.js'

const THROTTLE_API_TIMEOUT = 500 // in ms

function createAddressQueryParams(address) {
  return `${address.street}%2C+${address.city}%2C+${address.state}+${address.zip_code}`
}

export default {
  components: {
    Modal,
    Spinner,
  },
  props: {
    hereApiKey: String,
  },
  data() {
    return {
      currentAddressChoice: undefined,

      providedAddresses: undefined,
      checkedAddresses: {},

      pendingUserChoices: [],
      pendingEditAddresses: [],

      continueCheckLoop: true,
    }
  },
  methods: {
    checkAddresses(checkAddresses) {
      this.$refs['address-review-loading-modal'].openModal()

      this.currentAddressChoice = undefined

      this.providedAddresses = checkAddresses
      this.checkedAddresses = {}

      this.pendingUserChoices = []
      this.pendingEditAddresses = []

      this.continueCheckLoop = true
      this.runCheckLoop()
    },
    async runCheckLoop() {
      let firstRun = true
      let pair = this.providedAddresses.pop()
      while (this.continueCheckLoop && pair != undefined) {
        let addressKey = createAddressQueryParams(pair.address)
        if (!this.checkedAddresses[addressKey]) {
          this.checkedAddresses[addressKey] = [ pair.address ]
          if (!firstRun) {
            await new Promise(resolve => setTimeout(resolve, THROTTLE_API_TIMEOUT))
          }
          if (!this.validate(pair.key, pair.address, this.checkedAddresses[addressKey])) {
            return false
          }
        }
        else {
          this.checkedAddresses[addressKey].push(pair.address)
        }
        firstRun = false
        pair = this.providedAddresses.pop()
      }
      this.$refs['address-review-loading-modal'].closeModal()
      return true
    },
    async validate(addressType, address, identicalAddressList) {
      let isFilled = address.street != '' && address.city != '' && address.state != '' && address.zip_code != ''
      if (!isFilled) {
        notifications.pushError('Please make sure all required fields are filled.')
        this.continueCheckLoop = false
        this.$emit('reviewChange', false)
        return false
      }
      try {
        let query = createAddressQueryParams(address)
        let result = await fetch(`https://geocode.search.hereapi.com/v1/geocode?apiKey=${this.hereApiKey}&q=${query}`)
        if (result.status != 200) {
          throw new Error(result.statusText)
        }
        result = await result.json()
        if (result.items.length > 0) {
          let sortedQueryScore = result.items.toSorted((a, b) => -(a.scoring.queryScore - b.scoring.queryScore))
          let data = sortedQueryScore[0]
          let recommendedAddress = (data.address) ? data.address : null

          let addressPerfect = true
          if (data.scoring.queryScore < 0.98) {
            addressPerfect = false
          }
          else {
            for (const key of ['street', 'city', 'state', 'houseNumber', 'postalCode']) {
              if (data.scoring.fieldScore[key] < 0.99) {
                addressPerfect = false
                break
              }
            }
          }

          if (!addressPerfect) {
            this.$refs['address-review-loading-modal'].closeModal()
            this.addAddressToUserChoice(addressType, recommendedAddress, address, identicalAddressList)
          }
        }
        else {
          this.addAddressToUserChoice(addressType, null, address, identicalAddressList)
        }
      } catch (error) {
        console.error(error)
      }
    },
    addAddressToUserChoice(addressType, recommendedAddress, address, identicalAddressList) {
      this.pendingUserChoices.push({
        addressType,
        recommendedAddress,
        address,
        identicalAddressList,
      })

      if (this.currentAddressChoice === undefined) {
        this.setNextUserChoice()
      }
    },
    setNextUserChoice() {
      if (this.pendingUserChoices.length > 0) {
        let nextAddressUserChoice = this.pendingUserChoices.shift()
        this.currentAddressChoice = nextAddressUserChoice
        this.$refs['address-review-modal'].openModal()
      }
      else {
        this.editAddressObjects(this.pendingEditAddresses)
        this.$refs['address-review-modal'].closeModal()
      }
    },
    existingAddressOnClick() {
      this.setNextUserChoice()
    },
    suggestedAddressOnClick(addressType, recommendedAddress, identicalAddressList) {
      if (recommendedAddress === null) {
        this.$refs['address-review-modal'].closeModal()
        this.$emit('goBackAndEdit', addressType)
      } else {
        this.pendingEditAddresses.push([recommendedAddress, identicalAddressList])
        this.setNextUserChoice()
      }
    },
    getRecommendedAddressDisplay(recommendedAddress) {
      if (recommendedAddress === null) {
        return 'Go Back and Edit'
      }
      if (!recommendedAddress.street) {
        return recommendedAddress.label
      }
      let houseNumber = (recommendedAddress && recommendedAddress.houseNumber)
        ? recommendedAddress.houseNumber
        : ''
      let apartment = recommendedAddress.apartment
        ? ` ${recommendedAddress.apartment}`
        : ''
      return `${houseNumber} ${recommendedAddress?.street}${apartment}, ${recommendedAddress?.city}, ${recommendedAddress?.stateCode}, ${recommendedAddress?.postalCode}`
    },
    getInvalidAddress(address) {
      let currentAddress = address
      let apartment = currentAddress.apartment
        ? ` ${currentAddress.apartment}`
        : ''
      return `${currentAddress?.street}${apartment}, ${currentAddress?.city}, ${currentAddress?.state}, ${currentAddress?.zip_code}`
    },
    editAddressObjects(pendingEditAddresses) {
      for (const [newAddress, identicalAddressList] of pendingEditAddresses) {
        for (const addressObj of identicalAddressList) {
          this.setAddress(addressObj, newAddress)
        }
      }
    },
    setAddress(addressObj, newAddress) {
      this.$emit('setAddress', addressObj, newAddress)
      if (newAddress.houseNumber) {
        addressObj.street = newAddress.houseNumber + ' ' + newAddress.street
      } else {
        addressObj.street = newAddress.street
      }
      if (newAddress.apartment) {
        addressObj.apartment = newAddress.apartment
      }
      addressObj.city = newAddress.city
      addressObj.state = newAddress.stateCode
      addressObj.zip_code = newAddress.postalCode
    },
  },
  watch: {
    currentAddressChoice() {
      if (this.currentAddressChoice !== undefined) {
        this.$refs['address-review-modal'].openModal()
      }
    }
  },
}

</script>
